import { useUiStore } from '@/stores/ui.store'

export default defineNuxtPlugin((nuxtApp) => {
  const uiStore = useUiStore();
  if (process.client) {

    //Pega o tamanho da tela e verifica se é menor que 1024px
    let width = window.innerWidth;
    if (width < 1024) uiStore.avisoWidth = true;
    else uiStore.avisoWidth = false;

    //Adiciona um evento de resize para verificar se a tela é menor que 1024px
    //e setar o valor de avisoWidth no store
    window.addEventListener("resize", (e) => {
      let width = window.innerWidth;
      if (width < 1024) uiStore.avisoWidth = true;
      else uiStore.avisoWidth = false;
    });
  }
});
